import React from 'react'

export default function Thanks() {
    return (
        <div className='thank-msg'>
            <h2>Thank you for Ordering</h2>
            <p>Keep ordering</p>
        </div>
    )
}
